// polyfills for IE 11
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import './scripts/i18n.js';
import './scripts/modernizr.js';


// require('array.prototype.findindex').shim();
// require('array.prototype.find').shim();

ReactDOM.render(<App />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js